module.exports = __webpack_public_path__ + "img/gongan.58f55c5c.png";